module.exports = __webpack_public_path__ + "img/service-1.7a0c37d2.svg";